import { THEME, THEME_COLORS } from 'Src/constants'

export const getColorForTheme = (theme) => THEME_COLORS[theme] || THEME_COLORS[THEME.LIGHT]
